<template>
    <ToolTip :position="position" :alignment="alignment">
        <template #content>
            <template v-for="lang in languages" :key="lang">
                <div v-if="lang !== defaultLanguage">
                    <h4>{{ lang }}:</h4>
                    <div v-html="getTranslatedText(lang, textJson)"></div>
                </div>
            </template>
        </template>
        <template #hoverIcon><i class="fa-solid fa-language"></i></template>
    </ToolTip>
</template>

<script>
import ToolTip from '@/components/shared/ToolTip2.vue';
import {translation} from '../../shared/translation';

export default {
    name: 'TranslatedText',
    components: { ToolTip },
    props: {
        textJson: {
            type: Object,
            required: true
        },
        position: {
            type: String,
            default: 'right'
        },
        alignment: {
            type: String,
            default: 'end'
        },
        defaultLanguage: {
            type: String,
            required: true
        }
    },
    computed: {
        languages() {
            return this.textJson ? this.textJson.map(a => a.language) : [];
        }
    },
    methods: {
        getTranslatedText: function(language, json) {
            return translation.getTranslatedText(language, json).replace(/\n/g, '<br />');
        }
    }
}
</script>
<style scoped>
    :deep(.tooltip-slot-container) {
        font-size: 24px;
    }

    :deep(.tooltip-content) {
        background-color: white;
        border: 1px solid black;
        padding: 0 10px 10px 10px;
        min-width: 200px;
        border-radius: 10px;
        max-width: 400px;
        h4 {
            margin-bottom: 0;
        }
    }
</style>